module.exports = __webpack_public_path__ + "img/Pose de moustiquaire.d3cbf26a.jpg";